function importAll(r) {
    return r.keys().map(r);
  }
  
  const Spain_H = importAll(require.context('../assets/photos/Spain_H', false, /\.(png|jpe?g|svg)$/));
    
  export default Spain_H;